import { HomeComponent } from "./home";

export const components = [HomeComponent];

export { HomeComponent };
